import axiosInstance from '../helpers/axios';
import { getToken } from './auth';

// Get contact
export const getContacts = async () => {
	const token = getToken();
	return await axiosInstance({
		method: 'get',
		url: `/api/order/contact/?ordering=-created_at`,
		headers: { Authorization: 'Bearer ' + token },
	});
};

// Get contact
export const getOrderContacts = async (id) => {
	const token = getToken();
	return await axiosInstance({
		method: 'post',
		url: `/api/order/contacts`,
		headers: { Authorization: 'Bearer ' + token },
		data: { order_id: id },
	});
};

// Get contact's info
export const getContactInfo = async (idContact) => {
	const token = getToken();
	return await axiosInstance({
		method: 'get',
		url: `/api/order/contact/${idContact}`,
		headers: { Authorization: 'Bearer ' + token },
	});
};

// Register contact
export const registerContact = async (data) => {
	const token = getToken();
	return await axiosInstance({
		method: 'post',
		url: '/api/order/contact/',
		headers: { Authorization: 'Bearer ' + token },
		data,
	});
};

// Update contact
export const updateContact = async (idContact, data) => {
	const token = getToken();
	return await axiosInstance({
		method: 'put',
		url: `/api/order/contact/${idContact}`,
		headers: { Authorization: 'Bearer ' + token },
		data,
	});
};

// Delete contact
export const deleteContact = async (idContact, data) => {
	const token = getToken();
	return await axiosInstance({
		method: 'delete',
		url: `/api/order/contact/${idContact}`,
		headers: { Authorization: 'Bearer ' + token },
		data,
	});
};
